import React from 'react';
import { connect } from 'react-redux';
import { Input, Grid } from 'semantic-ui-react';
import {
  clientErrors, checkRequired, checkMaxLength, checkValidUrl,
} from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import UrlEditor from '@/components/text-editors/UrlEditor';
import { joinUrl, splitUrl } from '@/constants/urls';
import ColumnValidationError from '@/components/errors/ColumnValidationError';
import { mapStateToProps, mapDispatchToProps } from '../components/DatasetConditionContainer';
import UserDefinedTextRestrictionEditor, {
  validateUserDefinedTextRestriction,
} from './UserDefinedTextRestrictionEditor';

export const validateUserDefinedLinkRestriction = (datasetCondition, errors) => {
  const url = joinUrl(datasetCondition.context);
  const displayName = datasetCondition.context.link_display_name;
  const title = 'dataset.condition.validation.invalid.title';
  const entity = 'dataset.condition';

  checkRequired(url, [fields.LINK], errors, entity, title, true);
  checkValidUrl(url, [fields.LINK], errors, entity, title);
  checkMaxLength(displayName, [fields.LINK_DISPLAY_NAME], errors, entity, title, globalFieldLengths.code);

  validateUserDefinedTextRestriction(datasetCondition, errors, false);
};

const UserDefinedLinkRestrictionEditor = ({
  datasetCondition,
  updateProperties,
  saveErrors,
}) => {
  const linkError = clientErrors(saveErrors).find((e) => e.fields.includes(fields.LINK));
  const linkDisplayError = clientErrors(saveErrors).find((e) => e.fields.includes(fields.LINK_DISPLAY_NAME));

  const updateUriLink = (value) => updateProperties(splitUrl(value, datasetCondition.context.protocol));

  const updateUriProtocol = (value) => updateProperties({ protocol: value });

  return (
    <>
      <Grid columns="equal" className="mb-2">
        <Grid.Row>
          <ColumnValidationError
            error={linkError}
            htmlFor="ADDUC_0005_link"
            labelId="dataset.condition.restriction.link.label"
          >
            <UrlEditor
              value={datasetCondition.context.link}
              protocol={datasetCondition.context.protocol}
              onChange={(e) => updateUriLink(e.target.value)}
              onProtocolChange={(e, { value }) => { updateUriProtocol(value); }}
            />
          </ColumnValidationError>
          <ColumnValidationError
            error={linkDisplayError}
            htmlFor="ADDUC_0005_link_display"
            labelId="dataset.condition.restriction.link.display.label"
          >
            <Input
              value={datasetCondition.context.link_display_name}
              onChange={(e) => updateProperties({ link_display_name: e.target.value })}
              maxLength={globalFieldLengths.code}
            />
          </ColumnValidationError>
        </Grid.Row>
      </Grid>
      <UserDefinedTextRestrictionEditor />
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDefinedLinkRestrictionEditor);
